import type { AuthState, MutationClass } from '../../../models'

export class SetStateMutation implements MutationClass {
  static execute(this: void, state: AuthState, newState: Partial<AuthState>): void {
    Object.assign(state, newState)
  }
}
